// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Terms_componentWrapper__j1z9i","content":"Terms_content__pK23w"};